export enum StateType {
	NEW_STORE = 'new-store',
	EXISTING_SHOPIFY = 'existing-shopify',
	EXISTING_CSV = 'existing-csv',
}

export enum StateStatus {
	LOADING = 'loading',
	SUCCESS = 'success',
	ERROR = 'error',
}

export type OAuthState = {
	status: StateStatus;
	type?: StateType;
	error?: string;
};
